import './badge.css';
export default {
  "badge": "pf-c-badge",
  "modifiers": {
    "read": "pf-m-read",
    "unread": "pf-m-unread"
  },
  "themeDark": "pf-theme-dark"
};